import { render, staticRenderFns } from "./PlainTextField.vue?vue&type=template&id=28843103&"
import script from "./PlainTextField.vue?vue&type=script&lang=js&"
export * from "./PlainTextField.vue?vue&type=script&lang=js&"
import style0 from "./PlainTextField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports